/* global php_vars */

( function ($) {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	// var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	// var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
	// 	return new bootstrap.Popover( popoverTriggerEl, {
	// 		trigger: 'focus',
	// 	} );
	// } );

	$(document).ready(function () {

		//offcanvas click event
		$('#navbarNavDropdown a').click(  function() {
			let href = $(this).attr('href');
			// check if internal jumpmark link
			if( href.startsWith('/#') ) {
				const offcanvas = new bootstrap.Offcanvas('#navbarNavDropdown');
				// Bug bs5?? on init the canvas is not set to shown
				offcanvas._isShown = true;
				offcanvas.hide();
			}
		})

		// if clicked on a link with a hash, scroll to the anchor
		$('a[href*="#"]').click(function(e) {
			// check if internal jumpmark link
			if( $(this).attr('href').startsWith('#') ) {
				e.preventDefault();

				// if inside, remove / from the beginning
				if( $(this).attr('href').startsWith('/') ) {
					$(this).attr('href', $(this).attr('href').substring(1));
				}
				// get the target
				let target = $(this).attr('href');
				// scroll to the target
				console.log("Target: ", target);
				if( ! target || target === '#' ) {
					return;
				}
				$('html, body').animate({
					scrollTop: $(target).offset().top - php_vars.scroll_offset
				}, php_vars.scrollcontainer_speed);
			}
		});

		// jump to anchor with animation
		if(location.hash) {
			window.scrollTo({
				top: $(location.hash).offset().top,
				left: 0,
				behavior: "instant"
			})
			// $('html,body').scrollTop( $(location.hash).offset().top - 200, {
			//     duration: 0
			// })
		}

		// toggle menu class
		$('.dropdown-toggle--mobile').click( function(e) {
			let viewportWidth = window.innerWidth;
			if( viewportWidth < 1170 ) {
				e.preventDefault();
				$(this).parent().toggleClass('open');
				// $(this).find('.megamenu')
				$(this).parent().find('.offcanvas-mobile-dropdown').toggleClass('open');
			}
		});

		// same for dropdown-toggle--mobile--empty-link
		$('.dropdown-toggle--mobile--empty-link').click( function(e) {
			let viewportWidth = window.innerWidth;
			if( viewportWidth < 1170 ) {
				e.preventDefault();
				$(this).parent().toggleClass('open');
				// $(this).find('.megamenu')
				$(this).parent().find('.offcanvas-mobile-dropdown').toggleClass('open');
			}
		});

		$('.offcanvas-backlink').click( function(e) {
			e.preventDefault();
			$(this).parent().parent().removeClass('open');
		});

		// $('.has-megamenu a.dropdown-toggle').click(function (e) {
		//
		// 	// e.preventDefault();
		// 	// $(this).parent().toggleClass('open');
		// 	// if ($(this).parent().hasClass('open')) {
		// 	//     $('#wrapper-navbar').removeClass('has-bg');
		// 	// } else {
		// 	//     $('#wrapper-navbar').addClass('has-bg');
		// 	// }
		// })


	});
} )(jQuery);

document.addEventListener("DOMContentLoaded", function () {
	const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

	dropdownToggles.forEach(toggle => {
		const controlledMenuId = toggle.getAttribute('aria-controls');
		const menu = document.getElementById('parent-' + controlledMenuId);

		if (!menu) return;

		console.log(`Dropdown toggle for menu ${controlledMenuId} initialized.`);
		// Tastatursteuerung auf Toggle
		toggle.addEventListener("keydown", e => {
			if (e.key === "Enter" || e.key === "ArrowDown") {
				console.log(`Opening menu ${controlledMenuId} with key: ${e.key}`);
				e.preventDefault();
				openMenu(toggle, menu);
			}
		});

		// Klicke auf Toggle (für Touch / Maus)
		toggle.addEventListener("click", e => {
			const isOpen = toggle.getAttribute('aria-expanded') === "true";
			if (isOpen) {
				closeMenu(toggle, menu);
			} else {
				openMenu(toggle, menu);
			}
		});
	});

	// ESC schließt Menü
	document.addEventListener("keydown", e => {
		// close all open menus on ESC
		if (e.key === "Escape") {
			console.log("Closing all open menus with ESC key");
			closeAllMenus();
		}
	});

	function openMenu(toggle, menu) {
		closeAllMenus(); // optional: schließt andere Menüs
		menu.hidden = false;
		toggle.setAttribute("aria-expanded", "true");
		toggle.setAttribute("aria-haspopup", "true");
		menu.focus();
		console.log(`Menu ${menu.id} opened by toggle ${toggle.id}`);
		menu.classList.add('show');

		const firstItem = menu.querySelector('a');
		if (firstItem) firstItem.focus();
	}

	function closeMenu(toggle, menu) {
		menu.hidden = true;
		// all dropdown menus should be closed
		menu.classList.remove('show');
		toggle.setAttribute("aria-expanded", "false");
	}

	function closeAllMenus() {
		document.querySelectorAll('.dropdown-menu').forEach(menu => {
			menu.hidden = true;
			menu.classList.remove('show');
			const toggle = document.querySelector(`.dropdown-toggle[aria-controls="${menu.id}"]`);
			if (toggle) toggle.setAttribute("aria-expanded", "false");
		});
	}
});


(function mainScript() {
	// "use strict";
	// const offcanvasToggle = document.querySelector(
	//     '[data-bs-toggle="offcanvas"]',
	// );
	// const offcanvasCollapse = document.querySelector(".offcanvas-collapse");
	// offcanvasToggle.addEventListener("click", function () {
	//     console.log("Click");
	//     // offcanvasCollapse.classList.toggle("show");
	// });
})();
